export const LIST_RECIPIENTS_PAGE_SIZE = 25;

export const LIST_RECIPIENT_FILTER_SCHEMA = {
	search: { type: 'string', label: 'Suche' },
	hasEmail: { type: 'yesNo', label: 'E-Mail vorhanden' },
	hasAddress: { type: 'yesNo', label: 'Adresse vorhanden' },
};

export const BLACKLIST_PAGE_SIZE = 25;

export const BLACKLIST_ENTRY_TYPE_OPTIONS = [
	{ value: 'email', label: 'E-Mail' },
	{ value: 'domain', label: 'Domain' },
];

export const BLACKLIST_FILTER_SCHEMA = {
	search: { type: 'string', label: 'Suche' },
	entryType: { type: 'enumList', label: 'Typ', options: BLACKLIST_ENTRY_TYPE_OPTIONS },
};
